module.exports = __webpack_public_path__ + "static/img/how-to-align_zh.4ee4f8a4.gif";